<!-- 临时文件夹 -->
<template>
  <el-card>
    <div class="toolbar">
      <el-button type="success" size="small" @click="onGetItemList">
        <i class="el-icon-refresh" aria-hidden="true" /> 刷新
      </el-button>
      <el-button type="primary" size="small" @click="onDownloadClick">
        <i class="fas fa-download" aria-hidden="true" /> 打包下载
      </el-button>
      <div class="former">
        <el-button type="danger" size="small" @click="onDeleteItem">
          <i class="fas fa-trash-alt" aria-hidden="true" /> 清空文件夹
        </el-button>
      </div>
    </div>
    <el-table :data="itemList" v-loading="loading" tooltip-effect="light">
      <el-table-column
        type="index"
        :index="pager.size * (pager.page - 1) + 1"
        :width="Math.max(48, (pager.size * pager.page).toString().length * 12)"
      />
      <el-table-column prop="Name" label="文件名称" />
      <el-table-column prop="Size" label="文件大小(Byte)" width="150" />
      <el-table-column label="创建日期" width="180">
        <template slot-scope="{ row }">
          <span v-if="row.ModTime">{{
            $sys.dateFormat(row.ModTime, "Y-m-d H:i:s")
          }}</span>
        </template> </el-table-column
      >
      <el-table-column label="是否文件夹" width="80">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.IsDir" type="warning"> 是 </el-tag>
            <el-tag v-else type="success"> 否 </el-tag>
          </template>
        </el-table-column>
    </el-table>

  </el-card>
</template>

<script>

export default {
  components: {
  },
  data() {
    return {
      itemList: [],
      loading: false,
      pager: {
        total: 0,
        page: 1,
        size: 15,
      },
      former: {
      },
      key: "",
      uploadHeader: {
        Authorization: `Bearer ${window.localStorage.getItem("jwtToken")}`,
        Accept: "application/json",
      },
    };
  },
  created() {
    this.flush();
  },
  methods: {
    flush() {
      this.getItemList();
    },
    //获取列表
    getItemList() {
      this.loading = true;
      this.$axios
        .get("dci/temp/file", {
          params: {
            where: this.former,
            key: this.key,
            ...this.pager,
            order: ["-ModTime"],
          },
        })
        .then((response) => {
          this.itemList = response.data.data;
          this.pager = _.pick(response.data, "size", "page", "total");
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onSubmitQuery() {
      this.pager.page = 1;
      this.getItemList();
    },
    onChangePage(page) {
      this.pager.page = page;
      this.querier.page = page;
      this.getItemList();
    },
    onGetItemList() {
      this.getItemList();
    },
    //下载
    async onDownloadClick() {
      this.loading = true;
      const res = await this.$axios.request({
        url: "dci/temp/file/download",
        method: "get",
      });
      if (res.status !== 200) {
          ElMessage({
              type: 'error',
              message: '下载文件出错'
          })
          return
      }
      let filename = res.data;
      if (filename.indexOf("\\") !== -1) {
        const arr = filename.split("\\");
        filename = arr[arr.length - 1];
      }
      const a = document.createElement("a"); //创建a标签
      a.style.display = "none";
      a.href = res.data; // 指定下载链接
      a.download = filename; //指定下载文件名
      a.click(); //触发下载
      URL.revokeObjectURL(a.href); //释放URL对象
      this.loading = false;
    },
    //清空文件夹
    onDeleteItem() {
      this.$confirm("该操作将永久删除文件，确定要清空该临时文件夹吗？", "提示")
        .then(() =>
          this.$axios.request({
            url: "dci/temp/file",
            method: "delete",
          })
        )
        .then(() => {
          this.getItemList();
          this.$message.success("成功删除");
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        });
    },
  },
};
</script>

<style lang="scss">
.wiki-part {
  .el-tree-node__content {
    position: relative;
  }
  .show-node {
    flex: 1;
    display: flex;
    align-itemlist: center;
    justify-content: space-between;
    padding-right: 8px;
    font-size: 14px;
  }
  .adjust-btn {
    display: none;
    position: absolute;
    right: 15px;
  }
  .show-node:hover .adjust-btn {
    display: block;
  }
  .adjust-btn .el-button {
    margin: 0;
  }
}
.d-iblock {
  display: inline-block;
}
.standard-search {
  margin-right: 0.5em;
  .el-select {
    .el-input .el-input__inner {
      height: 28px !important;
    }
    .el-select__tags,
    .el-select__tags span {
      white-space: nowrap;
      overflow: hidden;
      flex-wrap: nowrap;
    }
  }
  vertical-align: middle;
}
</style>
